
import { motion } from "framer-motion";
import { Star } from "lucide-react";

// Reusable trust badges: used in CallToActionSection and Hero
const SocialTrustBadges = () => (
  <motion.div 
    className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-mobile-sm sm:text-sm text-muted-foreground"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.5, duration: 0.6 }}
  >
    <motion.div 
      className="flex items-center gap-3 bg-green-50/80 backdrop-blur-sm px-4 py-2 rounded-full border border-green-200/50"
      whileHover={{ scale: 1.05 }}
    >
      <div className="flex -space-x-2">
        {[1, 2, 3, 4].map((i) => (
          <motion.div 
            key={i} 
            className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/40 border-2 border-white shadow-lg"
            whileHover={{ scale: 1.1, zIndex: 10 }}
            transition={{ type: "spring", stiffness: 300 }}
          />
        ))}
      </div>
      <span className="ml-2 font-semibold text-green-700">Trusted by 50,000+ customers</span>
    </motion.div>
    <span className="hidden sm:inline text-muted-foreground/50">•</span>
    <motion.div 
      className="flex items-center gap-2 bg-yellow-50/80 backdrop-blur-sm px-4 py-2 rounded-full border border-yellow-200/50"
      whileHover={{ scale: 1.05 }}
    >
      <div className="flex">
        {[...Array(5)].map((_, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.7 + (i * 0.1), duration: 0.3 }}
          >
            <Star className="h-3 w-3 sm:h-4 sm:w-4 fill-yellow-400 text-yellow-400" />
          </motion.div>
        ))}
      </div>
      <span className="ml-2 font-semibold text-yellow-700">4.9/5 satisfaction</span>
    </motion.div>
  </motion.div>
);

export default SocialTrustBadges;
